/**
 * RWABS 商学苑 - 钱包连接工具
 * 支持 BSC 链上的 MetaMask / WalletConnect 连接
 * UniApp + Vue 2 + JavaScript 版本
 */

// BSC 链配置
var BSC_CONFIG = {
  mainnet: {
    chainId: 56,
    chainIdHex: '0x38',
    chainName: 'BNB Smart Chain',
    rpcUrl: 'https://bsc-rpc.publicnode.com',
    explorer: 'https://bscscan.com',
    symbol: 'BNB',
    decimals: 18,
    usdcAddress: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d',
    otmAddress: '0x47fFC6C0938aF8AAA2e9efd31e352f364c22Fdd0',
    mintAddress: '0xD7095A4756Dc852Cd3178fF6326087284662F1d7',
    // mintAddress: '0xb0A5C6D52BfC494bFA3BE299860975CDc5F262FB',
    apiUrl: 'http://rwabs-nft.io/api-proxy/appApi',
  },
  testnet: {
    chainId: 97,
    chainIdHex: '0x61',
    chainName: 'BSC Testnet',
    rpcUrl: 'https://data-seed-prebsc-1-s1.binance.org:8545/',
    explorer: 'https://testnet.bscscan.com',
    symbol: 'tBNB',
    decimals: 18,
    usdcAddress: '',
    otmAddress: '',
    mintAddress: '',
    apiUrl: 'http://rwabs-nft.io/api-proxy/appApi',
  }
}

// 合约地址配置（需要替换为实际部署的地址）
var CONTRACT_ADDRESSES = {
  mainnet: {
    nft: '0x...', // NFT 合约地址
    usdc: '0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d', // BSC USDC
    otm: '0x...' // OTM 代币地址
  },
  testnet: {
    nft: '0x...',
    usdc: '0x...',
    otm: '0x...'
  }
}

// 当前使用的网络
var CURRENT_NETWORK = 'mainnet'

/**
 * 检查是否安装了 MetaMask
 */
function hasMetaMask() {
  return typeof window !== 'undefined' && typeof window.ethereum !== 'undefined'
}

/**
 * 获取 ethereum provider
 */
function getProvider() {
  if (!hasMetaMask()) {
    throw new Error('请安装 MetaMask 钱包')
  }
  return window.ethereum
}

/**
 * 连接钱包
 */
function connectWallet() {
  return new Promise(function(resolve, reject) {
    var provider = getProvider()
    
    provider.request({
      method: 'eth_requestAccounts'
    }).then(function(accounts) {
      if (accounts.length === 0) {
        reject(new Error('未获取到账户'))
      } else {
        resolve(accounts[0])
      }
    }).catch(function(error) {
      if (error.code === 4001) {
        reject(new Error('用户拒绝连接'))
      } else {
        reject(error)
      }
    })
  })
}

/**
 * 获取当前连接的账户
 */
function getConnectedAccount() {
  return new Promise(function(resolve) {
    if (!hasMetaMask()) {
      resolve(null)
      return
    }
    
    var provider = getProvider()
    
    provider.request({
      method: 'eth_accounts'
    }).then(function(accounts) {
      resolve(accounts.length > 0 ? accounts[0] : null)
    }).catch(function() {
      resolve(null)
    })
  })
}

/**
 * 获取当前链 ID
 */
function getChainId() {
  return new Promise(function(resolve, reject) {
    var provider = getProvider()
    provider.request({ method: 'eth_chainId' }).then(function(chainIdHex) {
      resolve(parseInt(chainIdHex, 16))
    }).catch(reject)
  })
}

/**
 * 检查是否在正确的链上
 */
function isCorrectChain() {
  return new Promise(function(resolve) {
    getChainId().then(function(chainId) {
      var config = BSC_CONFIG[CURRENT_NETWORK]
      resolve(chainId === config.chainId)
    }).catch(function() {
      resolve(false)
    })
  })
}

/**
 * 切换到 BSC 链
 */
function switchToBSC() {
  return new Promise(function(resolve, reject) {
    var provider = getProvider()
    var config = BSC_CONFIG[CURRENT_NETWORK]
    
    provider.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: config.chainIdHex }]
    }).then(resolve).catch(function(error) {
      // 如果链不存在，添加链
      if (error.code === 4902) {
        provider.request({
          method: 'wallet_addEthereumChain',
          params: [{
            chainId: config.chainIdHex,
            chainName: config.chainName,
            nativeCurrency: {
              name: config.symbol,
              symbol: config.symbol,
              decimals: config.decimals
            },
            rpcUrls: [config.rpcUrl],
            blockExplorerUrls: [config.explorer]
          }]
        }).then(resolve).catch(reject)
      } else {
        reject(error)
      }
    })
  })
}

/**
 * 断开钱包连接（清除本地状态）
 */
function disconnectWallet() {
  // MetaMask 不支持程序化断开，只能清除本地状态
  // 实际断开需要用户在 MetaMask 中手动操作
}

/**
 * 格式化地址显示
 */
function formatAddress(address, prefixLength, suffixLength) {
  prefixLength = prefixLength || 6
  suffixLength = suffixLength || 4
  if (!address) return ''
  return address.slice(0, prefixLength) + '...' + address.slice(-suffixLength)
}

/**
 * 监听账户变化
 */
function onAccountsChanged(callback) {
  if (!hasMetaMask()) return
  var provider = getProvider()
  provider.on('accountsChanged', callback)
}

/**
 * 监听链变化
 */
function onChainChanged(callback) {
  if (!hasMetaMask()) return
  var provider = getProvider()
  provider.on('chainChanged', callback)
}

/**
 * 移除事件监听
 */
function removeAllListeners() {
  if (!hasMetaMask()) return
  var provider = getProvider()
  provider.removeAllListeners('accountsChanged')
  provider.removeAllListeners('chainChanged')
}

// 导出
export default {
  BSC_CONFIG: BSC_CONFIG,
  CONTRACT_ADDRESSES: CONTRACT_ADDRESSES,
  CURRENT_NETWORK: CURRENT_NETWORK,
  hasMetaMask: hasMetaMask,
  getProvider: getProvider,
  connectWallet: connectWallet,
  getConnectedAccount: getConnectedAccount,
  getChainId: getChainId,
  isCorrectChain: isCorrectChain,
  switchToBSC: switchToBSC,
  disconnectWallet: disconnectWallet,
  formatAddress: formatAddress,
  onAccountsChanged: onAccountsChanged,
  onChainChanged: onChainChanged,
  removeAllListeners: removeAllListeners
}
